import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AccountService { 
  baseUrl = environment.baseUrl;
  
  constructor(
    private router: Router, 
    private http: HttpClient, 
  ) { }

  // Capabilities
  getCapabilities$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.accounts}`;
    return this.http.get<any>(url + 'capabilities?uuid=' + uuid);
  }

  getAccountCapabilities$(userId: number, uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.accounts}`;
    return this.http.get<any>(url + userId + '/capabilities?uuid=' + uuid);
  }

  // Accounts
  getAccountsList$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.accounts}`;
    return this.http.get<any>(url + '?uuid=' + uuid);
  }

  // Profile
  getAccountProfile$(userId: number, uuid: string): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.accounts}`;
    return this.http.get<any>(url + userId + '/profile?uuid=' + uuid);
  }

  updateAccount$(userId: number, uuid: string, accountInfo: {}): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.accounts}`;
    return this.http.patch<any>(url + userId + '?uuid=' + uuid, accountInfo, httpOptions);
  }

  // https://api.montoitapp.ca/api/accounts/sales?uuid=4ca12f94-f36a-5b7d-a774-56512585842f
  getSales$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.accounts}`;
    return this.http.get<any>(url + 'sales?uuid=' + uuid);
  }

  // Session
  // https://dk90qm7un1jgu.cloudfront.net/api/accounts/1/session?uuid=f511a179-3fa6-5e6d-b800-9ba83ca42918
  getAccountSession$(uuid: string, accoundId: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.accounts}`;
    return this.http.get<any>(url + 'accounts/' + accoundId + '/session?uuid=' + uuid);  
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/accounts/1/session?uuid=f511a179-3fa6-5e6d-b800-9ba83ca42918
  patchAccountSession$(userId: number, uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.accounts}`;
    return this.http.get<any>(url + userId + '/capabilities?uuid=' + uuid);
  }

  deleteSession$(uuid: string, accoundId: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.accounts}`;
    return this.http.get<any>(url + accoundId + '/session?uuid=' + uuid);
  }

  notifySalesAppoitnment$(uuid: string, accoundId: number, noteId: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.accounts}`;
    return this.http.get<any>(url + 'sales/' + accoundId + '/notify/'+ noteId + '?uuid=' + uuid);
  }
}